module.exports = __webpack_public_path__ + "static/media/moons_comer_brackets-375.acb38329.webp";